import schoolAuth from "./schoolAuth";
import user from "./user";
import common from "./common";
import fcm from "./fcm";
import switchAccountChild from "./switchAccountChild";
import switchLanguage from "./switchLanguage";
import chat from "./chat";
import notify from "./notify";

export default {
  schoolAuth,
  user,
  common,
  fcm,
  switchAccountChild,
  switchLanguage,
  chat,
  notify
};
